import "core-js/modules/web.dom-collections.iterator.js";
import * as React from 'react';

// HoverHandler contains all of the logic necessary to determine whether the
// mouse is hovering over an element. You just have to bring your own element.
//
// HoverHandler passes two arguments to its children:
//
//   props - The props necessary to determine the hover state of an element.
//     These props should be passed to the hoverable element.
//
//   isHovering - Whether the mouse is hovering over the component.
class HoverHandler extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      isHovering: false
    };

    this.onMouseEnter = event => {
      this.setState({
        isHovering: true
      });
    };

    this.onMouseLeave = event => {
      this.setState({
        isHovering: false
      });
    };
  }

  render() {
    const {
      onMouseEnter,
      onMouseLeave
    } = this;
    const {
      isHovering
    } = this.state;
    return this.props.children({
      onMouseEnter,
      onMouseLeave
    }, isHovering);
  }

}

export default HoverHandler;